export const routes = {
  updateOrgCoordinates: () => `/kindergarten/organization/coordinate`,
};
